import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle
      sx={{ m: 0, p: 2 }}
      {...other}
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export const TableOrderTypeDialog = (props) => {
  const { openDialog, handleOrderType, typesettings } = props;
  const { DeliveryOrderOptions, PickupOrderOptions } = typesettings;

  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      open={openDialog}
      maxWidth="sm"
      fullWidth={true}
    >
      <BootstrapDialogTitle id="customized-dialog-title">
        <>Order Type:</>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexFlow: "row wrap",
          }}
        >
          {PickupOrderOptions == 1 ? (
            <Button
              variant="contained"
              color="primary"
              sx={{ width: "120px", margin: 1 }}
              onClick={() => handleOrderType("TakeOut")}
            >
              Take out
            </Button>
          ) : null}

          {DeliveryOrderOptions == 1 ? (
            <Button
              variant="contained"
              color="primary"
              sx={{ width: "120px", margin: 1 }}
              onClick={() => handleOrderType("Delivery")}
            >
              Delivery
            </Button>
          ) : null}
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};
